import { Slide, colors } from '@material-ui/core';
import { ClassAttributes, Component, ReactType, SyntheticEvent } from 'react';
import { css } from '@emotion/react';
import CustomSnackbar from '../CustomSnackbar';
import deepEqual from 'deep-equal';

interface Props {
  errors: Error[];
  onRequestClose: (e: SyntheticEvent<HTMLElement>, err: Error) => void;
  className?: string;
}

interface State {
  snackbarProps: SnackbarProps[];
}

interface SnackbarProps {
  id: number;
  error: Error;
  open: boolean;
  transition: ReactType;
}

class NonFatalErrorSnackbars extends Component<ClassAttributes<HTMLElement> & Props, State> {
  private lastErrorId: number;

  state: State = {
    snackbarProps: [],
  };

  constructor(props: ClassAttributes<HTMLElement> & Props) {
    super(props);

    this.lastErrorId = 0;
  }

  componentWillReceiveProps(nextProps: ClassAttributes<HTMLElement> & Props) {
    const added = nextProps.errors.reduce((whole, error) => {
      // added errors
      if (this.props.errors.indexOf(error) === -1) {
        this.lastErrorId += 1;

        return [
          ...whole,
          {
            id: this.lastErrorId,
            error,
            open: true,
            transition: (props: any) => <Slide direction="right" {...props} />,
          },
        ];
      }

      return whole;
    }, [] as SnackbarProps[]);

    const existed = this.state.snackbarProps.map((entry) => {
      // deleted errors
      if (nextProps.errors.indexOf(entry.error) === -1) {
        return { ...entry, open: false };
      }

      return entry;
    });

    this.setState({
      snackbarProps: Object.assign(existed, added, {}),
    });

    this.enqueueDeleteHiddenErrors();
  }

  shouldComponentUpdate(_: any, nextState: State) {
    return deepEqual(this.state.snackbarProps, nextState.snackbarProps);
  }

  render() {
    return this.state.snackbarProps.map(({ id, error }) => (
      <CustomSnackbar
        action="閉じる"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        message={error.message}
        onClickAction={(e) => this.props.onRequestClose(e, error)}
        onRequestClear={(e) => this.props.onRequestClose(e, error)}
        className={this.props.className}
        key={id}
        ContentProps={{
          classes: {
            root: css({ backgroundColor: colors.red[500] }).toString(),
          },
        }}
        buttonColor="inherit"
      />
    ));
  }

  private enqueueDeleteHiddenErrors = () => {
    setTimeout(
      () =>
        this.setState({
          snackbarProps: this.state.snackbarProps.filter(({ open }) => open),
        }),
      500,
    );
  };
}

export default NonFatalErrorSnackbars;
